import { I18nProvider } from "@refinedev/core";
import deCommon from "../locales/de/common.json";
import enCommon from "../locales/en/common.json";

const translations = {
  de: deCommon,
  en: enCommon,
};

export const i18nProvider: I18nProvider = {
  translate: (key: string, params: object = {}, locale = "de") => {
    const keys = key.split(".");
    let current: any = translations[locale as keyof typeof translations];

    for (const k of keys) {
      if (current) {
        current = current[k];
      }
    }

    if (typeof current !== "string") {
      return key;
    }

    let translated = current;

    Object.keys(params).forEach((param) => {
      translated = translated.replace(`:${param}`, (params as Record<string, string>)[param]);
    });

    return translated;
  },
  changeLocale: (locale: string) => {
    return Promise.resolve();
  },
  getLocale: () => {
    return "de";
  },
};
